import VueApexcharts from "vue3-apexcharts";

export default defineNuxtPlugin((app) => {
  app.vueApp.use(VueApexcharts);
  app.vueApp.component('apexcharts', VueApexcharts);
})
